var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 8.24609C12 8.24609 13.3333 9.57943 13.3333 11.2461C13.3333 11.8328 13.1667 12.3861 12.8733 12.8461L14.9267 14.9128L14 15.8394L11.92 13.7928C11.46 14.0794 10.9133 14.2461 10.3333 14.2461C8.66667 14.2461 7.33333 12.9128 7.33333 11.2461C7.33333 9.57943 8.66667 8.24609 10.3333 8.24609ZM10.3333 9.57943C9.89131 9.57943 9.46738 9.75502 9.15482 10.0676C8.84226 10.3801 8.66667 10.8041 8.66667 11.2461C8.66667 11.6881 8.84226 12.112 9.15482 12.4246C9.46738 12.7372 9.89131 12.9128 10.3333 12.9128C10.7754 12.9128 11.1993 12.7372 11.5118 12.4246C11.8244 12.112 12 11.6881 12 11.2461C12 10.8041 11.8244 10.3801 11.5118 10.0676C11.1993 9.75502 10.7754 9.57943 10.3333 9.57943ZM4.66667 10.2461V11.5794H6C6.09333 12.6128 6.53333 13.5394 7.20667 14.2461H3.33333C2.59333 14.2461 2 13.6461 2 12.9128V3.57943C2 2.83943 2.59333 2.24609 3.33333 2.24609H12.6667C13.0203 2.24609 13.3594 2.38657 13.6095 2.63662C13.8595 2.88667 14 3.22581 14 3.57943V8.93276C13.2333 7.71943 11.88 6.91276 10.3333 6.91276C9.48667 6.91276 8.69333 7.15943 8.02667 7.57943H4.66667V8.91276H6.66667C6.42667 9.31276 6.22667 9.76609 6.11333 10.2461H4.66667ZM11.3333 6.24609V4.91276H4.66667V6.24609H11.3333Z",
    fill: "#163C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlPanel);
export default __webpack_public_path__ + "static/media/controlPanel.624f9eb109c0142bb86e69ad8111b426.svg";
export { ForwardRef as ReactComponent };